import { Component, inject, Input, OnInit } from '@angular/core';
import { AverageTemperatureValue } from '@app/core/xprojector_backend/proto/xprojector.modulebms.customeradmin.pb';
import { XProjectorBmsCustomerAdminClient } from '@app/core/xprojector_backend/xprojector-bms-customeradmin-client';
import { CustomerSetting, GetCustomerSettingKey } from '@xprojectorcore/xprojector_backend/proto/xprojector.customeradmin.pb';
import { XProjectorCustomerAdminClient } from '@xprojectorcore/xprojector_backend/xprojector-customeradmin-client';
import { XprojAlertService, XprojModalService } from 'xproj-lib';

export class BmsCustomerSetting {
  customerSetting : CustomerSetting;
  value : number = undefined;
}

@Component({
  selector: 'bms-customer-settings',
  templateUrl: './bms-customer-settings.component.html',
  styleUrls: ['./bms-customer-settings.component.scss']
})
export class BmsCustomerSettingsComponent implements OnInit {

  @Input() customerId : string;
  @Input() userId : string;
  @Input() key : string;
  @Input() nodeId : string;
  @Input() nodeTypeId : string;
  @Input() admin : boolean;
  @Input() showAverageTemperature : boolean = true;

  private customerAdminClient: XProjectorCustomerAdminClient = inject(XProjectorCustomerAdminClient);
  private alertService: XprojAlertService = inject(XprojAlertService);
  private modalService: XprojModalService = inject(XprojModalService);
  private bmsCustomerAdminClient: XProjectorBmsCustomerAdminClient = inject(XProjectorBmsCustomerAdminClient);

  customerSettings : BmsCustomerSetting[] = [];
  customerSettingsKeys : GetCustomerSettingKey[] = [];
  loading: boolean = false;
  averageTemperatures : AverageTemperatureValue[];

  editCustomerSetting : CustomerSetting;

  CustomerSettingsValueType = CustomerSetting.CustomerSettingsValueType;
  CustomerSettingType = CustomerSetting.CustomerSettingType;

  constructor() { }

  ngOnInit() {
    this.updateKeys();
    this.updateCustomerSettings();
  }

  async updateKeys() {
    this.customerSettingsKeys = await this.customerAdminClient.getCustomerSettingKeys();
  }

  async updateCustomerSettings() {
    try {
      this.loading = true;
      this.customerSettings = [];
      let settings = await this.customerAdminClient.getCustomerSettings(this.customerId, this.nodeId, this.nodeTypeId, this.key, this.userId);
      settings.forEach(x => {
        let bmsSettings = new BmsCustomerSetting();
        bmsSettings.customerSetting = x;
        //bmsSettings.value = -999999;

        this.customerSettings.push(bmsSettings);
      });
      if (this.showAverageTemperature) {
        this.updateAverageTemperatures();
      }
    }
    finally {
      this.loading = false;
    }
  }

  async addCustomerSetting() {
    let newSetting = new CustomerSetting();
    newSetting.id = "0";
    newSetting.name = "<new>";
    newSetting.nodeId = this.nodeId;
    newSetting.nodeTypeId = this.nodeTypeId;
    if (this.nodeId?.length > 0) {
      newSetting.settingsType = CustomerSetting.CustomerSettingType.SYSTEM;
    }

    let bmsSettings = new BmsCustomerSetting();
    bmsSettings.customerSetting = newSetting;
    bmsSettings.value = -999999;

    this.customerSettings.push(bmsSettings);
  }

  async updateAverageTemperatures() {
    this.averageTemperatures = [];
    let ids : {nodeId : string, nodeTypeId : string}[] = [];
    this.customerSettings.forEach(x => {
      ids.push({nodeId : x.customerSetting.nodeId, nodeTypeId : x.customerSetting.nodeTypeId});
    });
    if (ids.length > 0) {
      let response = await this.bmsCustomerAdminClient.getAverageTemperature(this.customerId, ids, false, 1 );
      this.averageTemperatures = response.values;
      this.customerSettings.forEach(x => {
        let averageTemp = this.averageTemperatures.find(y => y.nodeId == x.customerSetting.nodeId && y.nodeTypeId == x.customerSetting.nodeTypeId);
        if (averageTemp) {
          x.value = averageTemp.value;
        }
      });
    }
  }

  async saveCustomerSetting(customerSetting : CustomerSetting) {
    if (customerSetting) {
      let result = await this.customerAdminClient.upsertCustomerSetting(this.customerId, customerSetting);

      if (!result.result) {
        this.alertService.error(result.message);
      }

      if (+customerSetting.id == 0) {
        await this.updateCustomerSettings();
      }
    }
  }

  async deleteCustomerSetting(customerSetting : CustomerSetting) {
    if (customerSetting) {
      if (+customerSetting.id > 0) {
        var doDelete = await this.modalService.ShowConfirmModalAsync({
          header: 'Delete customer settigns',
          description: 'Delete customer setting, are you sure?',
          ok: 'Ok',
          cancel: 'Cancel'
        });

        if (doDelete) {
          let result = await this.customerAdminClient.deleteCustomerSetting(this.customerId, customerSetting.id);

          if (!result.result) {
            this.alertService.error(result.message);
          }

          await this.updateCustomerSettings();
        }
      }
      else {
        this.customerSettings = this.customerSettings.filter(x => x.customerSetting.id != customerSetting.id);
      }
    }
  }

  editValue(customerSetting : CustomerSetting) {
    this.editCustomerSetting = customerSetting;
  }

  async cancelEditValue() {
    if (this.editCustomerSetting) {
      this.editCustomerSetting = undefined;
      await this.updateCustomerSettings();
    }
  }

  async saveEditValue() {
    if (this.editCustomerSetting) {
      let result = await this.customerAdminClient.upsertCustomerSetting(this.customerId, this.editCustomerSetting);

      if (!result.result) {
        this.alertService.error(result.message);
      }

      this.editCustomerSetting = undefined;
    }
  }
}
